// @flow
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import type { IntlShape } from 'react-intl';
import styles from './PlansOverviewSubscribe.css';

import {
  PLAN_ID_PPC_12M,
  PLAN_ID_PP_1M,
  SUBSCRIPTION_PLANS,
  PLAN_ID_PP_GROUP,
  PLAN_ID_PPC_GROUP,
} from '../../constants';

import { objectivesMessages, planTitleMessages } from '../messages/PlansOverviewMessages';
import PlanOptionSubscribe from './PlanOptionSubscribe';
import classNames from 'classnames';

type OwnProps = {
  setSelectedPlan: Function,
  selectedPlan: string,
  relativeDiscount?: number,
  isTrialAvailable: boolean,
  trialDurationDays: number,
};

type Props = OwnProps & {
  intl: IntlShape,
};

const PlansOverviewSubscribe = ({
  setSelectedPlan,
  selectedPlan,
  relativeDiscount,
  isTrialAvailable,
  trialDurationDays,
  intl,
}: Props) => {
  return (
    <React.Fragment>
      <PlanOptionSubscribe
        id={PLAN_ID_PP_1M}
        isSelected={PLAN_ID_PP_GROUP.includes(selectedPlan)}
        onSelect={setSelectedPlan}
        imageTitle={intl.formatMessage(planTitleMessages[PLAN_ID_PP_1M])}
        monthlyPrice={SUBSCRIPTION_PLANS[PLAN_ID_PP_1M].monthlyPrice}
        relativeDiscount={relativeDiscount}
        benefits={[
          {
            key: 'adFree',
            value: <FormattedMessage {...objectivesMessages.adFree} />,
          },
          {
            key: 'collection',
            value: <FormattedMessage {...objectivesMessages.collection} />,
          },
          {
            key: 'weeklyMixes',
            value: <FormattedMessage {...objectivesMessages.weeklyMixes} />,
          },
          {
            key: 'connect',
            value: <FormattedMessage {...objectivesMessages.connect} />,
          },
          {
            key: 'quality',
            value: <FormattedMessage {...objectivesMessages.quality} />,
          },
        ]}
        exclusions={[
          {
            key: 'concertAccess',
            value: <FormattedMessage {...objectivesMessages.concertAccess} />,
          },
        ]}
        className={styles.ppPlan}
        data-test="plan-option.premium-plus"
        isTrialAvailable={isTrialAvailable}
        trialDurationDays={trialDurationDays}
        planTag={
          <div className={classNames('u-tag', styles.planTag)}>
            <FormattedMessage
              id="subscribe-modal.premium.most-popular"
              defaultMessage="Most popular"
            />
          </div>
        }
      />
      <PlanOptionSubscribe
        id={PLAN_ID_PPC_12M}
        isSelected={PLAN_ID_PPC_GROUP.includes(selectedPlan)}
        onSelect={setSelectedPlan}
        imageTitle={intl.formatMessage(planTitleMessages[PLAN_ID_PPC_12M])}
        monthlyPrice={SUBSCRIPTION_PLANS[PLAN_ID_PPC_12M].monthlyPrice}
        relativeDiscount={relativeDiscount}
        priceTag="*"
        benefits={[
          {
            key: 'adFree',
            value: <FormattedMessage {...objectivesMessages.adFree} />,
          },
          {
            key: 'collection',
            value: <FormattedMessage {...objectivesMessages.collection} />,
          },
          {
            key: 'weeklyMixes',
            value: <FormattedMessage {...objectivesMessages.weeklyMixes} />,
          },
          {
            key: 'connect',
            value: <FormattedMessage {...objectivesMessages.connect} />,
          },
          {
            key: 'quality',
            value: <FormattedMessage {...objectivesMessages.quality} />,
          },
          {
            key: 'concertAccess',
            value: <FormattedMessage {...objectivesMessages.concertAccess} />,
          },
        ]}
        className={styles.ppcPlan}
        data-test="plan-option.premium-plus-concerts"
        isTrialAvailable={isTrialAvailable}
        trialDurationDays={trialDurationDays}
      />
    </React.Fragment>
  );
};

export default injectIntl(PlansOverviewSubscribe);
